import Vue from 'vue';
import { ColorPicker } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.component(ColorPicker.name, ColorPicker);
